/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import React from 'react'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { TextField } from '@mineral/core'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'
import dayjs from 'dayjs'
import './mineralDateTimePicker.less'

export const MineralDateTimePicker = ({
  id,
  disabled,
  label,
  value,
  placeholder,
  onValueChange,
  minDateTime,
  minDate,
  maxDate,
  maxDateTime,
}) => {
  const [dateValue, setValue] = React.useState(dayjs(value))
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateTimePicker
        id={id}
        label={label}
        value={dateValue}
        componentsProps={{
          switchViewButton: {
            sx: {
              margin: '20px 5px',
            },
          },
        }}
        onChangeRaw={ (e) => {
  e.preventDefault();
}}
        onChange={(newValue) => {
         let dateValue= newValue?.$d
        if(dateValue instanceof Date && !isNaN(dateValue))
        {
          setValue(newValue)
          onValueChange(newValue?.$d)
        }
        }
        }
        
        className="mineralDateTimePickerWidget"
        minDateTime={minDateTime ? dayjs(minDateTime) : undefined}
        maxDateTime={maxDateTime ? dayjs(maxDateTime) : undefined}
        minDate={minDate ? dayjs(minDate) : undefined}
        maxDate={maxDate ? dayjs(minDate) : undefined}
        disabled={disabled}
        PaperProps={{
          className: 'mineralDateTimePicker',
        }}
        PopperProps={{
          "aria-label":{label}
        }}
        InputProps={{
          className: 'mineralDateTimePicker_TextBox',
        }}
       OpenPickerButtonProps={{tooltip:'Change date'}}

        renderInput={(params) => (
          <TextField fullWidth={true}
            {...params}
            
            InputProps={{
              ...params.InputProps,
              style: { height: '32px'},
            }}
            inputProps={{
              ...params.inputProps,
              placeholder: placeholder || 'Select Date & Time',
              readOnly:true
            }}
            readOnly={true}
            
          />
        )}
      />
    </LocalizationProvider>
  )
}
